export interface PhonePrefix {
  code: string;
  country: string;
}

// Italia e Stati Uniti in cima (mercato principale + clienti/studi USA), poi resto del mondo.
export const PHONE_PREFIXES: PhonePrefix[] = [
  { code: '+39', country: 'Italia' },
  { code: '+1', country: 'Stati Uniti / Canada' },
  { code: '+41', country: 'Svizzera' },
  { code: '+378', country: 'San Marino' },
  { code: '+33', country: 'Francia' },
  { code: '+49', country: 'Germania' },
  { code: '+34', country: 'Spagna' },
  { code: '+44', country: 'Regno Unito' },
  { code: '+351', country: 'Portogallo' },
  { code: '+31', country: 'Paesi Bassi' },
  { code: '+32', country: 'Belgio' },
  { code: '+43', country: 'Austria' },
  { code: '+30', country: 'Grecia' },
  { code: '+385', country: 'Croazia' },
  { code: '+386', country: 'Slovenia' },
  { code: '+420', country: 'Repubblica Ceca' },
  { code: '+48', country: 'Polonia' },
  { code: '+36', country: 'Ungheria' },
  { code: '+40', country: 'Romania' },
  { code: '+353', country: 'Irlanda' },
  { code: '+45', country: 'Danimarca' },
  { code: '+46', country: 'Svezia' },
  { code: '+47', country: 'Norvegia' },
  { code: '+358', country: 'Finlandia' },
  { code: '+7', country: 'Russia' },
  { code: '+90', country: 'Turchia' },
  { code: '+61', country: 'Australia' },
  { code: '+81', country: 'Giappone' },
  { code: '+86', country: 'Cina' },
  { code: '+91', country: 'India' },
  { code: '+55', country: 'Brasile' },
  { code: '+52', country: 'Messico' },
  { code: '+27', country: 'Sudafrica' },
  { code: '+971', country: 'Emirati Arabi Uniti' },
];
